<template lang="pug">
.upgrade-wrapper(v-if="buyMemberData.upgradePopupImg")
  HighlightText.upgrade-title(
    :text="buyMemberData.handleCardUpRecommendText || ''"
    :normalStyle="normalTitleStyle"
    :highlightStyle="highlightTitleStyle"
  )
  .upgrade-content
    img(:src="buyMemberData.upgradePopupImg")
    .img-card-title {{`${remainDays}天体验版`}}
    .img-card-wrapper
      .card-left
        HighlightText.card-title(
          :text="cardTitle"
          :normalStyle="normalCardStyle"
          :highlightStyle="highlightCardStyle"
        )
        .card-detail {{cardSubTitle}}
      .card-remain-days {{remainDaysText}}
</template>
<script>
import HighlightText from '@/components/highlight-text.vue';
import { safeGet } from '@/utils';


export default {
  name: 'UpgradePopupV2',
  components: {
    HighlightText,
  },
  props: {
    buyMemberData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      rideCardInfoDTO: {},
      totalCardDays: 30,
      remainDays: 30,
      singlePayAmount: 0,
    };
  },
  computed: {
    // 单车卡标题
    cardTitle() {
      const useProperty = safeGet(this.rideCardInfoDTO, 'useProperty', {});
      if (!useProperty) return '';
      if (this.singlePayAmount > 0) return `${this.totalCardDays}}天卡 单单${this.singlePayAmount}元`;
      const { totalCardTimes } = useProperty;
      const isUnlimitedTimes = totalCardTimes === '不限' || !totalCardTimes;
      return isUnlimitedTimes ? `{${this.totalCardDays}}天不限次卡` : `{${this.totalCardDays}}天{${totalCardTimes}}次卡`;
    },
    // 单车卡副标题
    cardSubTitle() {
      if (this.rideCardInfoDTO && this.rideCardInfoDTO.deductRule) {
        const { rideFreeMinute, rideFreeCost } = this.rideCardInfoDTO.deductRule;
        if (this.singlePayAmount > 0) {
          return '生效中';
        }
        if (rideFreeMinute || rideFreeCost) {
          if (this.rideCardInfoDTO.businessId === 1) {
            return `生效中 | 单笔抵${rideFreeMinute}分钟`;
          }
          return `生效中 | 单笔抵${rideFreeCost}元`;
        }
      }
      return '生效中';
    },
    // 剩余天数显示
    remainDaysText() {
      if (this.rideCardInfoDTO) {
        const { remainDays, useProperty } = this.rideCardInfoDTO;
        if (this.singlePayAmount) return `剩${remainDays || 30}天`;
        // 判断是否为不限次卡
        const isUnlimitedCard = this.cardTitle.includes('不限次卡');
        if (isUnlimitedCard) {
          return `剩${remainDays || 30}天`;
        }
        return `剩${(useProperty && useProperty.remainCardTimes) || ''}次`;
      }
      return '';
    },
    normalTitleStyle() {
      return {
        fontWeight: '600',
        fontSize: '0.18rem',
        color: '#513d13',
      };
    },
    highlightTitleStyle() {
      return {
        fontWeight: '600',
        fontSize: '0.18rem',
        color: '#fa4614',
      };
    },
    normalCardStyle() {
      return {
        fontFamily: 'PingFang SC',
        fontWeight: '600',
        fontSize: '0.11rem',
        color: '#fff',
      };
    },
    highlightCardStyle() {
      return {
        fontFamily: 'DIN Alternate',
        fontWeight: '700',
        fontSize: '0.18rem',
        color: '#fff',
      };
    },
  },
  created() {
    if (this.buyMemberData && this.buyMemberData.rideCardInfoDTO) {
      this.rideCardInfoDTO = safeGet(this.buyMemberData, 'rideCardInfoDTO', {});
      this.totalCardDays = safeGet(this.rideCardInfoDTO, 'useProperty.totalCardDays', 30);
      this.remainDays = safeGet(this.rideCardInfoDTO, 'remainDays', 30);
      this.singlePayAmount = safeGet(this.rideCardInfoDTO, 'deductRule.payAmount', 0);
    } else {
      this.rideCardInfoDTO = {};
    }
  },
};
</script>
<style lang="less" scoped>
.upgrade-wrapper {
  padding-top: 0.18rem;

  .upgrade-title {
    padding-left: 0.21rem;
  }

  .upgrade-content {
    position: relative;
    margin: 0.15rem 0.12rem 0.11rem;
    height: 3.1rem;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .img-card-title {
      position: absolute;
      top: 0.02rem;
      left: 0.36rem;
      width: 1.23rem;
      height: 0.26rem;
      line-height: 0.26rem;
      font-size: 0.16rem;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .img-card-wrapper {
      position: absolute;
      top: 0.62rem;
      left: 0.15rem;
      width: 1.59rem;
      height: 0.55rem;
      padding-left: 0.09rem;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .card-left {
        display: flex;
        flex-direction: column;
        gap: 0.02rem;
        font-size: 0.11rem;
        color: #fff;

        .card-detail {
          font-size: 0.09rem;
          opacity: 0.5;
        }
      }

      .card-remain-days {
        margin-right: 0.13rem;
        font-size: 0.11rem;
        color: #fff;
        font-weight: 400;
      }
    }
  }
}
</style>
